module.exports = function getResource(label, vars = []) {
    const resources = {
        colorIQDesc: `Identifiez la teinte correcte pour chaque fond de teint et anticernes. Rendez-vous dans un [magasin Sephora|${vars[0]}] et demandez un balayage du ton de la peau Color IQ.`
    };
    return resources[label];
};
